import React from 'react';
import '../../FormBuilder.css';

const TwoDScanVehicleRegElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === '2dscanVehicleReg' && (
        <label className='titleTextLbl'>
            {component.fieldName || "2D Scan Vehicle Reg"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default TwoDScanVehicleRegElement;
